<template>
  <v-list-item>
    <template #prepend>
      <ReportIconAvatar
        :type="item.line_category"
        :icons="icons"
        @click="editLine"
      />
    </template>
    <template #default>
      <div class="day-report-content">
        <div class="content-html" v-html="$sanitizeHtml(item.content)"></div>
      </div>
    </template>
    <template #append>
      <div class="d-flex align-center ga-1">
        <v-btn
          v-if="canEdit"
          variant="text"
          icon
          size="small"
          :color="item.important ? 'red' : 'grey'"
          :title="
            item.important
              ? 'Markering belangrijk uitschakelen'
              : 'Markeer als belangrijk'
          "
          @click.stop="toggleImportant"
        >
          <v-icon>{{
            item.important ? "mdi-alert" : "mdi-alert-outline"
          }}</v-icon>
        </v-btn>
        <ContextMenu v-if="canEdit" :options="dayReportLineOptions" />
      </div>
    </template>
  </v-list-item>

  <!-- Delete confirmation moved outside the v-list-item -->
  <ConfirmationDialog
    v-model:model-value="deleteDialog"
    title="Lijn verwijderen"
    message="Weet je zeker dat je deze lijn wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt."
    @cancel="deleteDialog = false"
    @confirm="confirmDestroyLine"
  />
</template>

<script>
import ContextMenu from "../ui/ContextMenu.vue";
import ReportIconAvatar from "../ui/ReportIconAvatar.vue";
import ConfirmationDialog from "../ui/ConfirmationDialog.vue";
import { useFormsStore } from "@/stores/formsStore";
import { useDayReportLinesStoreRefactor } from "@/stores/dayReportLinesStoreRefactor";

export default {
  name: "DayReportLineListHourItem",
  components: {
    ContextMenu,
    ReportIconAvatar,
    ConfirmationDialog,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    icons: {
      type: Object,
      required: true,
    },
  },

  setup() {
    const formsStore = useFormsStore();
    const dayReportLinesStore = useDayReportLinesStoreRefactor();

    return {
      formsStore,
      dayReportLinesStore,
    };
  },

  data() {
    return {
      deleteDialog: false,
    };
  },

  computed: {
    canEdit() {
      return this.item.can_edit || this.item.can_destroy;
    },
    dayReportLineOptions() {
      const options = [];

      if (this.item.can_edit) {
        options.push({
          name: "Lijn wijzigen",
          action: this.editLine,
          icon: "mdi-playlist-edit",
        });
      }

      if (this.item.can_destroy) {
        options.push({
          name: "Lijn verwijderen",
          action: this.destroyLine,
          icon: "mdi-playlist-remove",
        });
      }

      return options;
    },
  },
  methods: {
    editLine() {
      this.formsStore.edit({
        type: "day_report_line",
        item: this.item,
      });
    },
    destroyLine() {
      this.deleteDialog = true;
    },
    async confirmDestroyLine() {
      try {
        await this.dayReportLinesStore.destroy(this.item);
      } catch (error) {
        console.error("Error deleting line:", error);
      } finally {
        this.deleteDialog = false;
      }
    },
    async toggleImportant() {
      try {
        const updated = { ...this.item, important: !this.item.important };
        await this.dayReportLinesStore.update(updated);
        this.item.important = updated.important;
      } catch (error) {
        console.error("Error toggling important:", error);
      }
    },
  },
};
</script>

<style scoped>
.v-list-item {
  padding: 0 16px;
}

.day-report-content {
  padding: 12px 0;
  width: 100%;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
}

.content-html {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: clip !important;
  line-height: 1.5;
}

.content-html :deep(p) {
  margin-bottom: 8px;
}

.content-html :deep(blockquote) {
  border-left: 3px solid rgba(0, 0, 0, 0.12);
  padding-left: 12px;
  margin: 8px 0;
  color: rgba(0, 0, 0, 0.6);
}
</style>
